<div
  class="modal fade"
  id="alert-modal"
  tabindex="-1"
  aria-labelledby="alert-modal-label"
  aria-hidden="true"
  >
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    [class.modal-sm]="!alertOptions?.size || alertOptions?.size === EnumAlertOptionSize.small"
    [class.modal-lg]="alertOptions?.size === EnumAlertOptionSize.large"
    [class.modal-xl]="alertOptions?.size === EnumAlertOptionSize.extraLarge"
    >
    <div class="modal-content">
      @if (alertOptions?.header?.display) {
        <div
          class="modal-header"
          [class.justify-content-center]="!alertOptions?.header?.closeBtn"
          >
          <h1
            class="modal-title fs-5"
            id="alert-modal-label"
            [innerText]="alertOptions?.header?.title || '' | translate"
          ></h1>
          @if (alertOptions?.header?.closeBtn) {
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              [attr.aria-label]="'GENERAL.CLOSE' | translate"
            ></button>
          }
        </div>
      }
      @if (alertOptions?.body?.text || alertOptions?.body?.checkboxOptions) {
        <div
          class="modal-body"
          [class.text-left]="alertOptions?.body?.textAlign === EnumAlertOptionTextAlign.left"
                [class.text-center]="
                    !alertOptions?.body?.textAlign ||
                    alertOptions?.body?.textAlign === EnumAlertOptionTextAlign.center
                "
                [class.text-right]="
                    alertOptions?.body?.textAlign === EnumAlertOptionTextAlign.right
                "
                [class.text-justify]="
                    alertOptions?.body?.textAlign === EnumAlertOptionTextAlign.justify
                "
                [class.justify-content-start]="
                    alertOptions?.body?.align === EnumAlertOptionFlexAlign.start
                "
                [class.justify-content-end]="
                    alertOptions?.body?.align === EnumAlertOptionFlexAlign.end
                "
                [class.justify-content-center]="
                    !alertOptions?.body?.align ||
                    alertOptions?.body?.align === EnumAlertOptionFlexAlign.center
                "
                [class.justify-content-between]="
                    alertOptions?.body?.align === EnumAlertOptionFlexAlign.between
                "
                [class.justify-content-around]="
                    alertOptions?.body?.align === EnumAlertOptionFlexAlign.around
                "
                [class.justify-content-evenly]="
                    alertOptions?.body?.align === EnumAlertOptionFlexAlign.evenly
                "
          >
          @if (alertOptions?.body?.text) {
            <div
              [innerHTML]="alertOptions!.body!.text! | translate"
            ></div>
          }
          @if (alertOptions?.body?.checkboxOptions) {
            <div class="list-group">
              <label
                class="list-group-item list-group-item-action d-flex align-items-center gap-2 fw-semibold"
                >
                <input
                  type="checkbox"
                  class="form-check-input m-0 flex-shrink-0"
                  id="alert-checkbox-all"
                  [checked]="allCheckboxesSelected"
                  (change)="setAllCheckboxes($any($event.target).checked)"
                  />
                <span [innerText]="'GENERAL.SELECT_ALL' | translate"></span>
              </label>
              @for (option of alertOptions?.body?.checkboxOptions; track option) {
                <label
                  class="list-group-item list-group-item-action d-flex align-items-center gap-2"
                  >
                  <input
                    type="checkbox"
                    class="form-check-input m-0 flex-shrink-0"
                    [id]="'alert-checkbox-' + option.value"
                    [checked]="isCheckboxSelected(option.value)"
                    (change)="toggleCheckbox(option.value, $any($event.target).checked)"
                    />
                  <span [innerText]="option.title | translate"></span>
                </label>
              }
            </div>
          }
        </div>
      }
      @if (alertOptions?.body?.dropdownOptions) {
        <div
          class="modal-body"
          [class.text-left]="alertOptions?.body?.textAlign === EnumAlertOptionTextAlign.left"
                [class.text-center]="
                    !alertOptions?.body?.textAlign ||
                    alertOptions?.body?.textAlign === EnumAlertOptionTextAlign.center
                "
                [class.text-right]="
                    alertOptions?.body?.textAlign === EnumAlertOptionTextAlign.right
                "
                [class.text-justify]="
                    alertOptions?.body?.textAlign === EnumAlertOptionTextAlign.justify
                "
                [class.justify-content-start]="
                    alertOptions?.body?.align === EnumAlertOptionFlexAlign.start
                "
                [class.justify-content-end]="
                    alertOptions?.body?.align === EnumAlertOptionFlexAlign.end
                "
                [class.justify-content-center]="
                    !alertOptions?.body?.align ||
                    alertOptions?.body?.align === EnumAlertOptionFlexAlign.center
                "
                [class.justify-content-between]="
                    alertOptions?.body?.align === EnumAlertOptionFlexAlign.between
                "
                [class.justify-content-around]="
                    alertOptions?.body?.align === EnumAlertOptionFlexAlign.around
                "
                [class.justify-content-evenly]="
                    alertOptions?.body?.align === EnumAlertOptionFlexAlign.evenly
                "
          >
          <div class="form-group mb-0">
            <select [(ngModel)]="dropdownValue" class="form-select">
              <option
                [ngValue]="null"
                [innerText]="'GENERAL.PLEASE_SELECT_ONE' | translate"
              ></option>
              @for (option of alertOptions?.body?.dropdownOptions; track option) {
                <option
                  [innerText]="option.title | translate"
                  [value]="option.value"
                ></option>
              }
            </select>
          </div>
        </div>
      }
      @if (alertOptions?.body?.input) {
        <div
          class="modal-body"
          [class.text-left]="alertOptions?.body?.textAlign === EnumAlertOptionTextAlign.left"
                [class.text-center]="
                    !alertOptions?.body?.textAlign ||
                    alertOptions?.body?.textAlign === EnumAlertOptionTextAlign.center
                "
                [class.text-right]="
                    alertOptions?.body?.textAlign === EnumAlertOptionTextAlign.right
                "
                [class.text-justify]="
                    alertOptions?.body?.textAlign === EnumAlertOptionTextAlign.justify
                "
          >
          <div class="form-group mb-0">
            <input
              type="text"
              class="form-control"
              [(ngModel)]="inputValue"
              [attr.placeholder]="alertOptions?.body?.input?.placeholder || '' | translate"
              />
          </div>
        </div>
      }
      @if (alertOptions?.footer?.display) {
        <div
          class="modal-footer"
                [class.justify-content-start]="
                    alertOptions?.footer?.align === EnumAlertOptionFlexAlign.start
                "
                [class.justify-content-end]="
                    alertOptions?.footer?.align === EnumAlertOptionFlexAlign.end
                "
                [class.justify-content-center]="
                    !alertOptions?.footer?.align ||
                    alertOptions?.footer?.align === EnumAlertOptionFlexAlign.center
                "
                [class.justify-content-between]="
                    alertOptions?.footer?.align === EnumAlertOptionFlexAlign.between
                "
                [class.justify-content-around]="
                    alertOptions?.footer?.align === EnumAlertOptionFlexAlign.around
                "
                [class.justify-content-evenly]="
                    alertOptions?.footer?.align === EnumAlertOptionFlexAlign.evenly
                "
          >
          @for (button of alertOptions?.footer?.buttons; track button) {
            <button
              type="button"
              class="btn {{ button.btnClass ?? 'btn-primary' }}"
              [attr.data-bs-dismiss]="button.closeModal ? 'modal' : ''"
                    [disabled]="
                        button.disabledWhenNoCheckboxSelected && !checkboxValues.length
                    "
              (click)="clickFooterBtn(button)"
              >
              @if (button.iconStart) {
                <fa-icon [icon]="button.iconStart"></fa-icon>
              }
              @if (button.text) {
                <span [innerText]="button.text | translate"></span>
              }
              @if (button.iconEnd) {
                <fa-icon [icon]="button.iconEnd"></fa-icon>
              }
            </button>
          }
        </div>
      }
    </div>
  </div>
</div>
